import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import useJob from '@/composables/useJob';
import usePlanner from '@/composables/usePlanner';
import useCompanyUser from '@/composables/useCompanyUser';
import useContract from '@/composables/useContract';
import useMessage from '@/composables/message/useMessage';
import useSuperAdminUser from '@/composables/useSuperAdminUser';
import { onMounted } from 'vue';
import { watch } from 'vue';
import { createContractDto } from '@/dtos/contractDto';
import { createMessageDto } from '@/dtos/messageDto';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Create',
    setup(__props) {
        const { jobs, fetchAllJob } = useJob();
        const { planners, fetchAllPlanner } = usePlanner();
        const { companyUsers, fetchCompanyUsersByJobId } = useCompanyUser();
        const { contracts, fetchData, storeContracts, form: contractExistsParam } = useContract();
        const { storeMessages } = useMessage();
        const { superAdminUser, fetchSuperAdminUser } = useSuperAdminUser();
        const form = ref({
            jobId: 0,
            companyId: 0,
            plannerIds: [],
            messageBody: '',
            messageToCompanyUserIds: [],
        });
        // 案件が選択された時の処理
        watch(() => form.value.jobId, async (jobId) => {
            if (jobId === 0 || jobId == null) {
                return;
            }
            const beforeCompanyId = form.value.companyId;
            await fetchCompanyUsersByJobId(jobId);
            setCompanyId();
            createDefaultMessageBody();
            const companyIsChanged = beforeCompanyId !== form.value.companyId;
            if (companyIsChanged && (form.value.messageToCompanyUserIds.length !== 0)) {
                form.value.messageToCompanyUserIds = [];
            }
            checkContractExists();
        });
        // 送信先企業ユーザーが選択されていなかったらメッセージ送信ボタンを無効にする
        watch(() => form.value.messageToCompanyUserIds, () => {
            createDefaultMessageBody();
        });
        watch(() => form.value.plannerIds, () => {
            checkContractExists();
            createDefaultMessageBody();
        });
        const createDefaultMessageBody = () => {
            if (form.value.jobId === 0 || form.value.plannerIds.length === 0 || form.value.messageToCompanyUserIds.length === 0) {
                return;
            }
            const selectedJob = jobs.value.find((job) => job.id === form.value.jobId);
            const selectedPlanners = planners.value.filter((planner) => form.value.plannerIds.includes(planner.id));
            const messageBody = `登録プランナーより【${selectedJob?.jobSections}】${selectedJob?.title}にエントリーがありました。\n` +
                `プロフィールをご確認いただき、よろしければプランナーとの面談の日程調整をお願いいたします。\n` +
                `※ プランナーとはメッセージにてやり取りすることが可能です。\n\n` +
                `${selectedPlanners.map((planner) => '【' + planner.name + 'さん】プロフィールURL: ' + `https://works.bridal-oshigoto.com/planner/${planner.accessCd}`).join('\n')}\n\n` +
                'ご確認のほどよろしくお願いいたします。';
            form.value.messageBody = messageBody;
        };
        const create = async () => {
            // フォームデータからContractを作成
            let contracts = [];
            for (let i = 0; i < form.value.plannerIds.length; i++) {
                const contract = createContractDto(form.value.jobId, form.value.plannerIds[i], form.value.companyId, 0);
                contracts.push(contract);
            }
            if (await storeContracts(contracts)) {
                window.alert('契約を作成しました。');
            }
        };
        const createAndSentMessage = async () => {
            if (superAdminUser.value === null) {
                window.alert('運営アカウントの取得に失敗しました。');
                return;
            }
            if (form.value.messageToCompanyUserIds.length === 0) {
                window.alert('送信先企業ユーザーを選択してください。');
                return;
            }
            if (form.value.messageBody === '') {
                window.alert('メッセージ本文を入力してください。');
                return;
            }
            create();
            let messages = [];
            // まずはフォームデータからMessagesを作成
            for (let i = 0; i < form.value.messageToCompanyUserIds.length; i++) {
                const message = createMessageDto(superAdminUser.value.id, form.value.messageToCompanyUserIds[i], form.value.messageBody, '');
                messages.push(message);
            }
            if (await storeMessages(messages)) {
                window.alert('メッセージを送信しました。');
            }
        };
        const setCompanyId = () => {
            if (companyUsers.value.length === 0) {
                return 0;
            }
            form.value.companyId = companyUsers.value[0].companyId;
        };
        const checkContractExists = async () => {
            if (form.value.jobId === 0 || form.value.plannerIds.length === 0) {
                return;
            }
            contractExistsParam.value.jobIds = [form.value.jobId]; // 案件IDは一つだけなので
            contractExistsParam.value.plannerIds = form.value.plannerIds;
            const jobSections = jobs.value.find((job) => job.id === form.value.jobId)?.jobSections;
            if (jobSections == null) {
                return;
            }
            contractExistsParam.value.jobSections = jobSections;
            await fetchData();
            if (contracts.value.length !== 0) {
                let message = '契約がすでに存在しています。\n';
                for (let i = 0; i < contracts.value.length; i++) {
                    message += `${contracts.value[i].plannerName} と ${contracts.value[i].jobTitle}\n`;
                }
                window.alert(message);
            }
        };
        onMounted(() => {
            fetchAllJob();
            fetchAllPlanner();
            fetchSuperAdminUser();
        });
        return (_ctx, _cache) => {
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createElementVNode("h1", null, "新しい契約を作成する", -1)
                        ])),
                        _: 1,
                        __: [4]
                    }),
                    _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_autocomplete, {
                                                modelValue: form.value.jobId,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.value.jobId) = $event)),
                                                label: "案件",
                                                items: _unref(jobs),
                                                "item-title": "fullTitle",
                                                "item-value": "id"
                                            }, null, 8, ["modelValue", "items"]),
                                            _createVNode(_component_v_autocomplete, {
                                                clearable: "",
                                                multiple: "",
                                                chips: "",
                                                modelValue: form.value.plannerIds,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.value.plannerIds) = $event)),
                                                label: "プランナー",
                                                items: _unref(planners),
                                                "item-title": "name",
                                                "item-value": "id"
                                            }, null, 8, ["modelValue", "items"]),
                                            _createVNode(_component_v_autocomplete, {
                                                clearable: "",
                                                chips: "",
                                                multiple: "",
                                                disabled: form.value.jobId === 0,
                                                modelValue: form.value.messageToCompanyUserIds,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.value.messageToCompanyUserIds) = $event)),
                                                label: "メッセージ送信先企業ユーザー",
                                                items: _unref(companyUsers),
                                                "item-title": "name",
                                                "item-value": "userId"
                                            }, null, 8, ["disabled", "modelValue", "items"]),
                                            _createVNode(_component_v_textarea, {
                                                outlined: "",
                                                "auto-grow": "",
                                                label: "企業向けメッセージ",
                                                modelValue: form.value.messageBody,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.messageBody) = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                class: "mr-4",
                                                onClick: createAndSentMessage,
                                                color: "primary",
                                                disabled: _unref(contracts).length > 0
                                            }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                    _createTextVNode("メッセージを送信して作成")
                                                ])),
                                                _: 1,
                                                __: [5]
                                            }, 8, ["disabled"]),
                                            _createVNode(_component_v_btn, {
                                                class: "mr-4",
                                                onClick: create,
                                                color: "secondary",
                                                disabled: _unref(contracts).length > 0
                                            }, {
                                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                    _createTextVNode("メッセージを送信しないで作成")
                                                ])),
                                                _: 1,
                                                __: [6]
                                            }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
